export default "__VITE_ASSET__Bn1CQIAq__"